import { useState, useCallback, useEffect } from "react";
import type { StepId } from "../types";

interface UseStepNavigationProps {
  initialStep?: StepId;
  onStepChange?: (stepId: StepId) => void;
}

/**
 * Separate hook for managing step navigation state
 * This is isolated from form wizard logic to prevent conflicts
 */
export function useStepNavigation({
  initialStep = "property-type",
  onStepChange,
}: UseStepNavigationProps = {}) {
  const [currentStepId, setCurrentStepId] = useState<StepId>(initialStep);

  // Navigation function that can be called from outside
  const navigateToStep = useCallback((stepId: StepId) => {
    setCurrentStepId(stepId);
  }, []);

  // Notify parent of step changes
  useEffect(() => {
    onStepChange?.(currentStepId);
  }, [currentStepId, onStepChange]);

  return {
    currentStepId,
    navigateToStep,
    setCurrentStepId, // Also expose setter for internal use
  };
}


